import * as React from "react";


import './AddThisBlock.css';

function AddThisBlock() {
    return (
        <div className="add-this-block-container">

            <div>

                <div className="addthis_inline_share_toolbox_g0o3"></div>
            </div>

            <script type="text/javascript" src="//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-597d29b3b4e298a5"></script>

        </div>
    );
}

export default AddThisBlock;
